import {
    faFacebookSquare,
    faGithubSquare,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import FriendsAdda from "../../images/friendsAdda.png";
import FancySlider from "../../images/Screenshot454.png";
import EasyFix from "../../images/Screenshot_3.png";
import TechZone from "../../images/Screenshot_4.png";
import transportApp from "../../images/Screenshot_5.png";
import FootballLeague from "../../images/Screenshot_6.png";
import Footer from "../Footer/Footer";
import Header from "../Home/Header/Header";
import Work from "../Work/Work";

const Works = () => {
    const works = [
        {
            img: EasyFix,
            name: "Easy Fix - MERN Stack Website",
            desc: "It's a single page application, where anyone can book a electronics service. He can see his orders and status. An Admin can change status and add new service, delete service and make another admin too.",
            tech: "Html5, Css3, Bootstrap4, React JS, Node JS, Express JS and Mongodb.",
            site: "https://easy-fix-affce.web.app/",
            client: "https://github.com/saurav-ghosh/Easy-Fix-Client",
            server: "https://github.com/saurav-ghosh/Easy-Fix-Server",
        },
        {
            img: TechZone,
            name: "Tech Zone - MERN Stack Website",
            desc: "It's an simple e-commerce website. With this app anyone can buy any products. He can see his all orders.He can add any product or delete any product and can see the result in the home page",
            tech: "Html5, Css3, Bootstrap4, React JS, Node JS, Express JS and Mongodb.",
            site: "https://tech-zone-dd59d.web.app/",
            client: "https://github.com/saurav-ghosh/Tech-Zone-Client",
            server: "https://github.com/saurav-ghosh/Tech-Zone-server",
        },
        {
            img: FriendsAdda,
            name: "FriendsAdda - Chatting Application (Team Project)",
            desc: "It's a real time chatting application. User can sign in with google authentication and create a message room. Then he can chat with other person in the same room. User can also log out.",
            tech: " Html5, Css3, javascript, React JS, firebase",
            site: "https://discord-group-2c7c1.firebaseapp.com/",
            client: "https://github.com/ahadhossainaiman/friendsAdda",
        },
        {
            img: transportApp,
            name: "Rajdhani Transport - Web Application",
            desc: "It's a ride sharing web application. One can choose any kind of vehicle to go anywhere. Then he can select his destination. And see the available vehicle and also see the destination on the map.",
            tech: " Html5, Css3, Bootstrap4, javascript, React JS",
            site: "https://rajdhani-transports.web.app/",
            client: "https://github.com/saurav-ghosh/Rajdhani-Transport",
        },
        {
            img: FancySlider,
            name: "Fancy Slider - Web Application",
            desc: "Fancy Slider is slider making application. You can search any kind of picture and select them for make a slider. You can also set slider duration.",
            tech: " Html5, Css3, Bootstrap4, javascript",
            site: "https://saurav-ghosh.github.io/fancy-slider/index.html ",
            client: "https://github.com/saurav-ghosh/fancy-slider",
        },
        {
            img: FootballLeague,
            name: "English League - Web Application",
            desc: "It's English Football League. Where all the club are showing on the home page. One can select any club to see the detail of the club.",
            tech: " Html5, Css3, Bootstrap4, javascript, React JS",
            site: "https://lucid-mayer-a5bc3c.netlify.app/",
            client: "https://github.com/saurav-ghosh/English-League",
        },
    ];
    return (
        <div className="container">
            <Header></Header>
            <h3 className="skills mt-3 ms-5">My Works</h3>
            <div className="row mt-5 ms-3">
                {works.map((work) => (
                    <Work work={work}></Work>
                ))}
            </div>
            <div className="contact-icon">
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                >
                    <FontAwesomeIcon className="icon" icon={faLinkedin} />
                </a>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/saurav-ghosh"
                >
                    <FontAwesomeIcon className="icon" icon={faGithubSquare} />
                </a>
                <Link to="/contact">
                    <FontAwesomeIcon className="icon" icon={faEnvelopeSquare} />
                </Link>
                <FontAwesomeIcon className="icon" icon={faFacebookSquare} />
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Works;
